import chatbotRequest from '../http'
import type { CreateTelegramChannelReq, CreateTelegramChannelRes } from '../types/createTelegramChannel'

export function createTelegramChannelApi(data: CreateTelegramChannelReq): Promise<CreateTelegramChannelRes> {
    return chatbotRequest<CreateTelegramChannelRes, CreateTelegramChannelReq, CreateTelegramChannelRes>({
        url: '/api/channel/create/telegram',
        method: 'post',
        data,
    })
}